export default "__VITE_ASSET__41098d0a__"